const modelName = 'Privacy Policies';
const modelNameSingular = 'Privacy Policie';
const endpoint = '/privacy-policy';

const setup = {
    title: modelName,
    singular: modelNameSingular,
    model: modelName.replace(/\s+/g, '-').toLowerCase(),
    canDelete: true,
    canAddNew: true,
    canSearch: true,
    endpoint,
    accessor: 'id',
};

export default setup;
